/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ApolloError } from "@apollo/client";
import { useDeleteUserMutation } from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  onError?: () => void;
};

export function useDeleteUser({ onError }: Props) {
  const [deleteUserMutation, { client, ...rest }] = useDeleteUserMutation();

  async function deleteUser(userId: string) {
    try {
      await deleteUserMutation({
        variables: {
          userId,
        },
      });
    } catch (error) {
      if ((error as ApolloError).message.toLowerCase().includes("not found")) {
        return;
      }
      showError(error.message);
      onError?.();
      throw error;
    }
  }

  return [deleteUser, { client, ...rest }] as const;
}
